/** Pure helpers shared by the QR generation preview and its tests. */

export function sequenceToLetters(blockIndex: number): string {
  let n = blockIndex + 1
  let letters = ''
  while (n > 0) {
    const remainder = (n - 1) % 26
    letters = String.fromCharCode(65 + remainder) + letters
    n = Math.floor((n - 1) / 26)
  }
  return letters
}

export function sequenceToSuffix(sequence: number): string {
  const block = Math.floor(sequence / 1000)
  const number = sequence % 1000
  return `${sequenceToLetters(block)}${String(number).padStart(3, '0')}`
}

/** The letter before the number: B = bag tag, L = seal strip (uc-core `kindPrefix`). */
export function kindPrefix(kind: 'BAG' | 'SEAL'): string {
  return kind === 'SEAL' ? 'L' : 'B'
}

export function qrPayload(
  stateCode: string,
  villageCode: string,
  sequence: number,
  kind: 'BAG' | 'SEAL' = 'BAG',
): string {
  return `${stateCode}-${villageCode}-${kindPrefix(kind)}${sequenceToSuffix(sequence)}`
}

export function safeQrFilename(value: string): string {
  return (
    value
      .trim()
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/^-+|-+$/g, '') || 'batch'
  )
}
